'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _interopRequireDefault = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _React = require('react');

var _React2 = _interopRequireDefault(_React);

var _classNames = require('classnames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styleMaps = require('./styleMaps');

var _styleMaps2 = _interopRequireDefault(_styleMaps);

var Col = _React2['default'].createClass({
  displayName: 'Col',

  propTypes: {
    xs: _React2['default'].PropTypes.number,
    sm: _React2['default'].PropTypes.number,
    md: _React2['default'].PropTypes.number,
    lg: _React2['default'].PropTypes.number,
    xsOffset: _React2['default'].PropTypes.number,
    smOffset: _React2['default'].PropTypes.number,
    mdOffset: _React2['default'].PropTypes.number,
    lgOffset: _React2['default'].PropTypes.number,
    xsPush: _React2['default'].PropTypes.number,
    smPush: _React2['default'].PropTypes.number,
    mdPush: _React2['default'].PropTypes.number,
    lgPush: _React2['default'].PropTypes.number,
    xsPull: _React2['default'].PropTypes.number,
    smPull: _React2['default'].PropTypes.number,
    mdPull: _React2['default'].PropTypes.number,
    lgPull: _React2['default'].PropTypes.number,
    componentClass: _React2['default'].PropTypes.node.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      componentClass: 'div'
    };
  },

  render: function render() {
    var ComponentClass = this.props.componentClass;
    var classes = {};

    Object.keys(_styleMaps2['default'].SIZES).forEach(function (key) {
      var size = _styleMaps2['default'].SIZES[key];
      var prop = size;
      var classPart = size + '-';

      if (this.props[prop]) {
        classes['col-' + classPart + this.props[prop]] = true;
      }

      prop = size + 'Offset';
      classPart = size + '-offset-';
      if (this.props[prop] >= 0) {
        classes['col-' + classPart + this.props[prop]] = true;
      }

      prop = size + 'Push';
      classPart = size + '-push-';
      if (this.props[prop] >= 0) {
        classes['col-' + classPart + this.props[prop]] = true;
      }

      prop = size + 'Pull';
      classPart = size + '-pull-';
      if (this.props[prop] >= 0) {
        classes['col-' + classPart + this.props[prop]] = true;
      }
    }, this);

    return _React2['default'].createElement(
      ComponentClass,
      _extends({}, this.props, { className: _classNames2['default'](this.props.className, classes) }),
      this.props.children
    );
  }
});

exports['default'] = Col;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/Col.js
 ** module id = 210
 ** module chunks = 0
 **/